import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class SectionHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    getAllSections(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/section/getAllSections`);
    }

    getSectionById(sectionId: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/section/getSectionById`, { params: { sectionId: sectionId } });
    }

    newSection(section: any): Observable<any> {
        return this.http.post<any>(`${this.configurations.baseUrl}/api/section/newSection`, section);
    }

    editSection(section: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/section/editSection`, section);
    }

    deleteSection(sectionId: any): Observable<any> {
        return this.http.delete<any>(`${this.configurations.baseUrl}/api/section/deleteSection`, { params: { sectionId: sectionId } });
    }

    togglePublishSection(sectionId: any, value: any): Observable<any> {
        return this.http.put<any>(
            `${this.configurations.baseUrl}/api/section/togglePublishSection`,
            {},
            {
                params: { sectionId: sectionId, value: value },
            }
        );
    }
}
